import {
    type CalloutSettings,
    type OutreachTemplate,
} from '@libraries/typescript/api_client';

export function resolveAutomaticShiftGroupMode(
    outreachType: OutreachTemplate['outreach_type'],
    calloutSettings:
        | Pick<
              CalloutSettings,
              | 'auto_group_default'
              | 'default_shift_group_mode'
              | 'recurring_shift_default_group_mode'
          >
        | null
        | undefined,
): 'all' | 'any' | undefined {
    if (outreachType === 'recurring_shift') {
        return calloutSettings?.recurring_shift_default_group_mode === 'none'
            ? undefined
            : 'all';
    }
    if (calloutSettings?.auto_group_default === 'off') {
        return undefined;
    }
    return calloutSettings?.default_shift_group_mode ?? 'any';
}
